import * as React from 'react';
import { useCallback } from 'react';

export const useOutsideClick = (
  elementRef: React.RefObject<HTMLElement | null>,
  isOpen: boolean,
  handler: () => void,
) => {
  const handleClick = useCallback(
    (e: MouseEvent) => {
      if (!elementRef || !elementRef.current) {
        return;
      }

      if (!elementRef.current.contains(e.target as Node)) {
        handler();
      }
    },
    [elementRef, handler],
  );

  React.useEffect(() => {
    if (!isOpen) {
      return;
    }

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick, isOpen]);
};
